import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Button, Form, Input, InputNumber, Select } from 'antd';
import moment from 'moment';
import api from '../../apis';
import { useNavigate } from 'react-router-dom';
import UserAccTreeSelect from '../general/form-control/user-acc-tree-select';
import { useFilter } from '../../context/FilterContext';
import { numberWithCommas } from '../general/convertor';
import { showMessageModal,showSuccessMessageModal } from '../utils';

const { Option } = Select;
const inputClass ="custom";

const WithdrawalModal = ({
    children,
    data,
    onSubmit
}:any) => {
  const [form] = Form.useForm();
  const [trustData, setTrustData] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [currentAccNo, setCurrentAccNo] = useState('');
  const { filterParams } = useFilter();
  const navigate = useNavigate();

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [initialValues, setInitialValues] = useState({});

    // useEffect(() => {
    //     if(isModalVisible == true){
    //         setInitialValues(data)
    //     }
    // }, [isModalVisible]);

    useEffect(() => {
        handleCurrentAccount(filterParams);
    }, [filterParams]);

    // Function to show the modal
    const showModal = () => {
        setIsModalVisible(true);
    };

    // Function to hide the modal
    const handleOk = () => {
        setIsModalVisible(false);
    };

    // Function to hide the modal on cancel
    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };


  useEffect(() => {
      // requestSearchClientNameAccount();
  }, []);

  useEffect(() => {
      
      if(currentAccNo && isModalVisible == true){
        console.log('currentAccNo',currentAccNo)
        requestGetTrustDetailAPI(currentAccNo);
      }
     
  }, [isModalVisible,currentAccNo]);

  const requestGetTrustDetailAPI = async (accNo: any) => {
    //   form.setFieldValue('currency_text', "");
    //   form.setFieldValue('at_curr_trdlimit', "");
   
        if(accNo){
                setTrustData([]);
                //update form currentAccount
                handleCurrentAccount(filterParams);
                let result = await api.getTrustDetailOption(accNo);

                if (result.trusts) {
                    setTrustData(result.trusts);
                    handleCurrencyOptions(result.trusts);
                    // let at_curr_trdlimit = result.at_curr_trdlimit || 0;
                    // let c_code = result.c_code || '';

                    // form.setFieldValue('currency_text', c_code);
                    // form.setFieldValue('at_curr_trdlimit', at_curr_trdlimit);
                    // setAvailTrustAmount(result.at_curr_trdlimit || 0);
                    //setTableData(contra);
                    //  updateAccSummaryComponent(account);
                }
        }
      
  };

  const handleCurrencyOptions = (data:any) => {
    let currencyOptions = data.map((item:any) => {
      return {
        label: item.c_code,
        value: item.at_cid
      }
    });
    setCurrencyOptions(currencyOptions);    
  }

  const handleCurrencyChange = (value:string) => {

    let trust_amount = 0;
    let currencyOptions = trustData.map((item:any) => {
      if(item.at_cid == value){
        trust_amount = item.at_balance_amt + item.at_accured_interest;
      }
    })
    form.setFieldValue('trust_amount', numberWithCommas(trust_amount, 2));
  }

  const handleCurrentAccount = (filterParams:any)=>{
    form.setFieldsValue({
        currentAccNo: null,
    });
    setCurrentAccNo("");

    if(!filterParams) return;
    if(!filterParams["accounts[]"]) return;

    if(filterParams["accounts[]"].length <1) return;


    form.setFieldsValue({
        currentAccNoTitle: filterParams["accounts_details[]"][0].title,
    });

    setCurrentAccNo(filterParams["accounts[]"][0]);
  }

  

//   const onValuesChange = (values: any) => {   
//     //   console.log("onValuesChange",values);
//       //map values to form fields
//       form.setFieldsValue({
//           currentAccNo: values["accounts[]"][0],
//       });
//       setCurrentAccNo(values["accounts[]"][0]);
//   };

  const onFinishFailed = (errorInfo: any) => {
      console.log('Failed:', errorInfo);
  };

  const onFinish = async (values: any) => {
    //  console.log('Success:', currentAccNo," ",values);

     setLoading(true);

      let result = await api.submitWithdrawal(currentAccNo, values);
      setLoading(false);
      if (result.status == 0) {
          //alert('Submit withdrawel successful');
          showSuccessMessageModal('Submit withdrawel successful');
          //refresh page
        //   navigate(0);
            handleModalClose();
      } else {
        
          if (result?.message) {
              let message = result?.message;
              let sentence = '';

              for (var key of Object.keys(message)) {
                  sentence += message[key];
              }

            //  alert(sentence);
              showMessageModal(sentence);
          }
      }

  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    form.resetFields();
    //callback parent
    onSubmit();
  }

  return (
    <div>

      <span onClick={showModal}  >
        <u className='cursor-pointer'>
        {
            children
        }

        </u>
      </span>

      <Modal
        title="Withdrawal"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        width={"90vw"}
        style={{ maxWidth: '1200px' }} 
        destroyOnClose={true}
      >
 
        <Form
            form={form}
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 8 }}
            initialValues={{
                date_requested: moment().format('DD/MM/YYYY'),
                type:"Online Transfer"
              }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            size="large"
            style={{width:'100%'}}
        >
            
            <Form.Item
                label="Username / Account No"
                name="currentAccNoTitle"
                rules={[{ required: true, message: 'Please input' }]}
            >
                   <Input className={inputClass} disabled/>
                  {/* <UserAccTreeSelect
                    // mode={mode}
                        singleMode={true}


                        onSelectedDetails={(values:string,selectedDetails: string) =>
                        {
                                // setCurrentAccNo(values);
                                // setCurrentAccDetails(selectedDetails);
                                console.log("onValueChange",values,selectedDetails)
                                onValuesChange({    
                                    "accounts[]":values,
                                    "accounts_details[]":selectedDetails
                                });
                                // if(onValuesChange){
                                //     onValuesChange({
                                //         "accounts[]":values,
                                //         "accounts_details[]":selectedDetails
                                //     });
                                // }
                            
                        }
                    }
                /> */}
            </Form.Item>

            <Form.Item
                label="Date Requested"
                name="date_requested"
                rules={[{ required: true, message: 'Please input' }]}
            >
                <Input className={inputClass} disabled/>
            </Form.Item>
            

            <Form.Item
                label="Currency"
                name="currency"  
                rules={[{ required: true, message: 'Please select currency' }]}
            >
                   <Select placeholder="Please select currency" onChange={handleCurrencyChange}  >
                    {currencyOptions.map(option => (
                        <Option key={option.value} value={option.value}>
                        {option.label}
                        </Option>
                    ))}
                    </Select>
            
        
            </Form.Item>

            <Form.Item
                label="Current Available Trust Amount"
                name="trust_amount"
            >
                <Input className={inputClass} disabled/>
            </Form.Item>

            

            <Form.Item
                label="Type"
                name="type"
                rules={[{ required: true, message: 'Please input' }]}
            >
                <Input  className={inputClass} disabled/>
            </Form.Item>

            <Form.Item
                label="Withdrawal Amount"
                name="amount"
                rules={[
                    { 
                        required: true, message: 'Please input',
                    },
                    {
                      pattern: /^\d+(\.\d{1,2})?$/,
                      message: 'Only numbers are allowed',
                    },
                    
                    
                    {
                      pattern: /^(0\.(0[1-9]|[1-9]\d{0,2})|[1-9]\d*(\.\d{1,2})?)$/,
                      message: 'The number must be at least 0.01',
                   }
                  
                ]}
             
            >
                <Input  className={inputClass}    
                  onChange={(e) => {
                    const rawValue = e.target.value;
                      // Remove invalid characters (anything not 0-9 or .)
                    const filtered = rawValue.replace(/[^0-9.]/g, '');

                    // Prevent multiple dots
                    const parts = filtered.split('.');
                    let newValue = parts[0];

                    if (parts.length > 1) {
                      newValue += '.' + parts[1].slice(0, 2); // keep only first 2 digits after dot
                    }
        
                    // Update form field
                    form.setFieldsValue({ amount: newValue });
                  }}
                />
            </Form.Item>
    


            <Form.Item wrapperCol={{sm:{ offset: 8, span: 16 }}} className='pt-4'>
            <div>
                <Button type="primary" htmlType="submit" className='btn-primary-custom btn-md' loading={loading}>
                    Submit
                </Button>
            </div>
            </Form.Item>
        </Form>
        
      </Modal>
    </div>
  );
};

export default WithdrawalModal;